<template>
  <section
    class="collapse-container"
    :class="{ open: showContent, animate: animate }"
  >
    <div class="collapse-toggle" @click="toggleContent">
      <slot name="toggle"> </slot>
      <icon v-if="chevron" class="collapse-icon" :icon="toggleIcon" size="sm">
      </icon>
    </div>
    <div
      class="collapse-content"
      :style="cssVars"
      ref="toggleContent"
      :aria-expanded="showContent"
    >
      <slot name="content"> </slot>
    </div>
  </section>
</template>

<script>
import Icon from 'vue-elements/icon/Icon.vue';
export default {
  name: 'Collapse',
  props: {
    startOpen: {
      type: Boolean,
      default: false,
    },
    chevron: {
      type: Boolean,
      default: true,
    },
    responsive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showContent: true,
      maxHeight: '9999px',
      animate: false,
    };
  },
  components: {
    Icon,
  },
  mounted() {
    // Set the max-height of the collapse-content as css variable
    this.setMaxHeight();
    // Set the showContent state to match desired start state
    this.showContent = this.startOpen;
    // Wait for initial values to be set before alowing animations
    setTimeout(() => {
      this.animate = true;
    }, 20);
  },
  methods: {
    setMaxHeight() {
      this.maxHeight = this.$refs.toggleContent.clientHeight + 'px';
    },
    toggleContent() {
      this.showContent = !this.showContent;
    },
  },

  computed: {
    cssVars() {
      return {
        '--contentHeight': `${this.maxHeight}`,
      };
    },
    toggleIcon() {
      return 'chevron-down';
    },
  },
};
</script>

<style lang="scss" scoped>
@use './collapse';
.collapse-container {
  @include collapse.bordered;
}
</style>
